export default function ($translate) {
    return {
        KEYS: {
            TOTAL_AMOUNT: 'TOTAL_AMOUNT',
            CATEGORY: 'CATEGORY'
        },
        LABELS: {
            TOTAL_AMOUNT: $translate.instant('formsQuestionsSettings.By total amount'),
            CATEGORY: $translate.instant('formsQuestionsSettings.By category')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/forms/randomized/type/index.js